import React, { Component } from 'react';
import { getCurrentResource } from '../../util/tools';
import PlainFullDescription from '../../components/fulldescription/PlainFullDescription';
import styles from '../../components/fulldescription/FullDescription.module.css';
import { FORM_CLASSIFIER_FT } from '../../util/consts/forms';

class ClassifierPage extends Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().pages.plain.Classifier;
	}

	plainInfo = {
		app: this.props.app,
		instanceModelId: FORM_CLASSIFIER_FT,
		instanceId: this.props.match.params.id
	};

	render() {
		return (
			<React.Fragment>
				<div className={styles.divPlainTitle}>
					{this.resource.title}
				</div>
				<PlainFullDescription plain={this.plainInfo} />
			</React.Fragment>
		)
	}
}

export default ClassifierPage;
